import React from "react";
import { Helmet } from "react-helmet";

const HelmetProvider = ({ children }) => (
  <>
    <Helmet>
      <meta http-equiv="X-Frame-Options" content="SAMEORIGIN" />
      <meta
        http-equiv="Content-Security-Policy"
        content="frame-ancestors 'self'"
      />
    </Helmet>
    {children}
  </>
);

export default HelmetProvider;
